module.exports = __webpack_public_path__ + "media/images/icons/ic-telephone-d0b4d50471d31d8b61d57bcae1313734.svg";